import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../shared/shared.service';

@Component({
  selector: 'app-answer-modal',
  templateUrl: './answer-modal.component.html',
  styleUrls: ['./answer-modal.component.css'],
})
export class AnswerModalComponent implements OnInit {
  constructor(
    private sharedService: SharedService
  ) {}

  ngOnInit() {}

  actionYES() {
    this.sharedService.actionYESEvent.next(true);
    this.sharedService.closeAnswerModal();
  }
}
